module.exports = require('./src/normalizeWheel.js');



//////////////////
// WEBPACK FOOTER
// ./node_modules/normalize-wheel/index.js
// module id = 3fo+
// module chunks = 23